export enum QuestionType {
    LANGUAGE_SELECTION = "LANGUAGE_SELECTION",
    PROFESSION_SELECTION = "PROFESSION_SELECTION",
    CUSTOM_OCCUPATION_INPUT = "CUSTOM_OCCUPATION_INPUT",
    PROFESSION = 'PROFESSION',
    PERSONAL = 'PERSONAL',
    CV_UPLOAD = 'CV_UPLOAD',
    ACTION = "ACTION",
    CLOSING = "CLOSING",
}

export enum Language {
    EN = 'EN',
    DE = 'DE',
    NL = 'NL',
    PL = 'PL',
    RU = 'RU',
    HU = 'HU',
    FR = 'FR',
    RO = 'RO',
    ES = 'ES',
    IT = 'IT',
    CS = 'CS',
    BG = 'BG',
    HR = 'HR',
    TR = 'TR',
    PT = 'PT',
    LT = 'LT',
    LV = 'LV',
    EE = 'EE',
    SK = 'SK',
    SL = 'SL',
}

export enum AnswerType {
    BOOLEAN = 'BOOLEAN',
    DATE = 'DATE',
    RADIO = 'RADIO',
    MULTISELECT = 'MULTISELECT',
    FILE = 'FILE',
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    TEXT_AREA = 'TEXT_AREA',
    LIST_OBJECT = 'LIST_OBJECT'
}


export enum QuestionDataKey {
    FIRST_NAME = 'firstName',
    MIDDLE_NAME = 'middleName',
    LAST_NAME = 'lastName',
    DATE_OF_BIRTH = 'dateOfBirth',
    PHONE_NUMBER = 'phoneNumber',
    EMAIL = 'emailAddress',
    NATIONALITY = 'nationality',
    ORIGIN_COUNTRY = 'originCountry',
    ORIGIN_CITY = 'originCity',
    WILLING_TO_WORK_IN_NETHERLANDS = 'willingToWorkInNetherlands',
    HOUSING_NEEDED = 'housingNeeded',
    OWN_TRANSPORT = 'ownTransport',
    DESIRED_COMPENSATION_BASIS = 'desiredCompensationBasis',
    DESIRED_COMPENSATION_AMOUNT = 'desiredCompensationAmount',
    DRIVING_LICENSE_B = 'drivingLicenseB',
    INTERVIEW_AVAILABILITY = 'interviewAvailability',
    ZZP_STATUS = 'zzp',
    LANGUAGE = 'language',
    PROFESSION = 'professionKey',
    CUSTOM_OCCUPATION = 'customOccupation',
}

export interface QuestionOption {
    key: string;
    label: string;
}

export interface ListItemFieldDefinition {
    fieldName: string;
    label: string;
    fieldType: AnswerType;
    isRequired?: boolean;
}

export interface QuestionDto {
    id?: number;
    questionKey: string;
    questionName: string;
    question: string;
    questionShorten: string;
    questionNumber: number;
    questionVersion: number;
    professionKey: string | null;
    language: Language;
    questionType: QuestionType;
    questionDataKey?: QuestionDataKey | null;
    answerType: AnswerType;
    isRequiredAnswer: boolean;
    next?: number | Record<string, number> | null;
    options?: QuestionOption[];
    listItemSchema?: ListItemFieldDefinition[];
    requiresVerification?: boolean;
    minItems?: number;
    maxItems?: number;
}

export interface CreateQuestionDto {
    questionKey: string;
    questionName: string;
    question: string;
    questionShorten: string;
    questionNumber: number;
    questionVersion: number;
    professionKey?: string | null;
    language: Language;
    questionType: QuestionType;
    questionDataKey?: QuestionDataKey | null;
    answerType: AnswerType;
    isRequiredAnswer: boolean;
    next?: number | Record<string, number> | null;
    options?: QuestionOption[];
    listItemSchema?: ListItemFieldDefinition[];
    requiresVerification?: boolean;
    minItems?: number;
    maxItems?: number;
}

export interface UpdateQuestionDto {
    questionKey?: string;
    questionName?: string;
    question?: string;
    questionShorten?: string;
    questionNumber?: number;
    questionVersion?: number;
    professionKey?: string | null;
    language?: Language;
    questionType?: QuestionType;
    questionDataKey?: QuestionDataKey | null;
    answerType?: AnswerType;
    isRequiredAnswer?: boolean;
    next?: number | Record<string, number> | null;
    options?: QuestionOption[];
    listItemSchema?: ListItemFieldDefinition[];
    requiresVerification?: boolean;
    minItems?: number;
    maxItems?: number;
}

export interface Question {
    id: number;
    question: string;
    questionShorten: string;
    questionNumber: number;
    questionVersion: number;
    professionKey: string;
    questionType: QuestionType;
    next: number | Record<string, number> | null;
    options?: string[];
}

export interface QuestionQueryFilters {
    professionKey?: string;
    questionType?: QuestionType;
    language?: Language;
    questionId?: number;
} 
